import React from 'react';
import { LinearProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui';
import OLYWebPageComponent from '../../OLYWebPageComponent';
import { translate } from 'react-i18next';
import SpecialDestinationTable from './SpecialDestinationTable';
import { getSpecialDestinations } from '../SpecialDestinationServices';

const styles = theme => ({
    column: {
        flexBasis: '33.33%'
    },
    columnall: {
        flexBasis: '77.77%',
        marginRight: '64px'
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: '#3155A1'
    },
    button: {
        height: '42px',
        width: '190px',
        marginTop: '24px'
    },
    filterTitle: {
        color: theme.palette.primary.contrastText,
        fontSize: '16px'
    },
    expansionPanelFilter: {
        backgroundColor: theme.palette.primary.main
    },
    expansionIcon: {
        color: theme.palette.primary.contrastText
    }
});

/**
 * 
 */
class SpecialDestinationView extends OLYWebPageComponent {

    constructor(props) {
        super(props);

        this.pageName = 'SpecialDestination';
        this.pageReference = '';

        this.state = {
            data: [],
            loading: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchBackendData();
    }

    handleSubmit = () => {
        this.fetchBackendData();
    };

    fetchBackendData = async (value) => {
        this.setState({ loading: true });
        try {
            const { type } = this.props;
            const specialDestinations = await getSpecialDestinations(value, '', type);
            this.setState({ data: specialDestinations, loading: false });
        }
        catch (error) {
            this.setState({ loading: false });
        }
    };

    render() {
        const { type } = this.props;
        return (
            <div>
                {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                <SpecialDestinationTable
                    data={this.state.data}
                    fetchBackendData={this.fetchBackendData}
                    type={type}
                />
            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(SpecialDestinationView));



// WEBPACK FOOTER //
// ./src/components/SpecialDestinations/Table/SpecialDestinationView.js